import { RequestState } from '../../../types'

export type Certificate = {
  id: string
  label: string
  key: string
  active: boolean
  demo: boolean
  createdAt: Date
  deactivatedAt: Date
  deleteRequestState: RequestState
}

export type CertificateSettingsState = {
  list: { 
    certificates: Certificate[]
    requestState: RequestState
  },
  add: {    
    catalogue: Certificate[]
    requestState: RequestState
    certificate: string
    name: string
  }
}

export const initialCertificateSettingsState = {
  list: {
    certificates: [],
    requestState: RequestState.NotLoaded
  },
  add: {
    catalogue: [],
    requestState: RequestState.NotLoaded,
    certificate: '',
    name: ''
  }  
}